import UserPassengerListRequest, {
  UserPassengerListRequestStatusCriteria,
  UserPassengerListRequestOrder,
} from "../../../../api/raily/user/passenger/list/user-passenger-list.request";
import UserOrder from "../../../../types/user-order";
import UserStatus from "../../../../types/user-status";
import paginationService from "../../../../utils/pagination/pagination.service";
import UserPassengerListParams from "./user-passenger-list-params";

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserPassengerListRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserPassengerListRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserPassengerListRequestStatusCriteria.DELETED;
    default:
      return UserPassengerListRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserOrder | undefined,
): UserPassengerListRequestOrder | undefined => {
  switch (status) {
    case UserOrder.FIRST_NAME_ASC:
      return UserPassengerListRequestOrder.FIRST_NAME_ASC;
    case UserOrder.FIRST_NAME_DESC:
      return UserPassengerListRequestOrder.FIRST_NAME_DESC;
    case UserOrder.LAST_NAME_ASC:
      return UserPassengerListRequestOrder.LAST_NAME_ASC;
    case UserOrder.LAST_NAME_DESC:
      return UserPassengerListRequestOrder.LAST_NAME_DESC;
    case UserOrder.USERNAME_ASC:
      return UserPassengerListRequestOrder.USERNAME_ASC;
    case UserOrder.USERNAME_DESC:
      return UserPassengerListRequestOrder.USERNAME_DESC;
    default:
      return undefined;
  }
};

const create = (params: UserPassengerListParams): UserPassengerListRequest => {
  return {
    cargoCompany: params.cargoCompany,
    cargoCompanyId: params.cargoCompanyId,
    dispatch: params.dispatch,
    dispatchId: params.dispatchId,
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    statusCriteria: createStatusCriteria(params.status),
    username: params.username,
    creationEnd: params.creationEnd,
    creationStart: params.creationStart,
    limit: params.pageSize,
    address: params.address,
  };
};

const userPassengerListParamsFactory = { create };

export default userPassengerListParamsFactory;
